import React, { useEffect, useState } from "react";
import "./ProfilePage.css";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import dummyProfile from "../../images/dummyProfile.jpg";
import CountrySelect from "../countrySelect";
import { useAlert } from "react-alert";
import api from "../../api";
import userAction from "../../redux/users/action";
import { Edit, Eye, EyeOff } from "lucide-react";
import { Modal } from "react-bootstrap";
import OtpInput from "react-otp-input";

const ProfilePage = () => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const dispatch = useDispatch();
  const { setUser } = userAction;

  const [userData, setUserData] = useState({});
  const [inputData, setInputData] = useState({});
  const [openEdit, setOpenEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [imgLoader, setImgLoader] = useState(false);
  const [showPassModal, setShowPassModal] = useState(false);

  useEffect(() => {
    setUserData(userStore?.users?.user || {});
    setInputData(userStore?.users?.user || {});
  }, [userStore?.users]);

  const onTextChange = (e) => {
    if (e.label) {
      setInputData({ ...inputData, country: e.label });
    } else {
      setInputData({ ...inputData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async () => {
    try {
      if (!inputData?.name) {
        alert.show("Please insert name");
        return;
      }
      if (!inputData?.dob) {
        alert.show("Please insert DOB");
        return;
      }

      if (!inputData?.country) {
        alert.show("Please select country");
        return;
      }
      setLoader(true);
      const formData = {
        ...inputData,
        // dob: `${data?.year}-${data?.month}-${data?.day}`,
      };

      const signalResponse = await api.userProfileEdit(formData);
      // console.log(signalResponse);

      if (signalResponse?.success) {
        let updatedData = userStore?.users;
        updatedData.user.name = inputData.name;
        updatedData.user.dob = inputData.dob;
        updatedData.user.country = inputData.country;
        dispatch(setUser(updatedData));
        alert.show("Profile Updated Successfully");
        setOpenEdit(false);
        setLoader(false);
      } else {
        setLoader(false);
        alert.show("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert.show("Something went wrong");
    }
  };

  const handleImgUpload = async (e) => {
    try {
      // console.log(e.target.files);
      setImgLoader(true);

      const formData = new FormData();
      formData.append("image", e.target.files[0], e.target.files[0].name);
      const response = await api.updateUserProfileImg(formData);
      if (response?.success) {
        let updatedData = userStore?.users;
        updatedData.user.profileImg = response?.profileImg;
        dispatch(setUser(updatedData));
      } else {
        alert.show("Image upload failed");
      }
      setImgLoader(false);
    } catch (e) {
      alert.show("Image upload failed");
      setImgLoader(false);
      console.log(e);
    }
  };

  return (
    <div className="profile-wrapper py-5">
      <div className="container">
        {/* Title */}
        <div className="text-center mb-5">
          <h1 className="profile-title">Profile Details</h1>
          <p className="profile-subtitle">
            Manage your personal details and keep your account information up to
            date.
          </p>
        </div>

        {/* Top Section */}
        <div className="row g-4 align-items-start">
          {/* Left Column */}
          <div className="col-lg-4 order-2 order-lg-1">
            <div className="info-card">
              <div className="card-header-gradient">
                Contact & Account Details
              </div>

              <div className="p-4">
                <p>
                  <strong>Email:</strong> {userData?.email}
                  {/* <span className="verified-badge ms-2">✓</span> */}
                  <RiVerifiedBadgeFill
                    className="color-verified"
                    fontSize={22}
                  />
                </p>

                <p>
                  <strong>Phone Number:</strong> {userData?.phone || "-"}
                </p>

                <p>
                  <strong>Account Created:</strong> {userData?.createdAt}
                </p>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-8 order-1 order-lg-2">
            <div className="profile-card p-3">
              <div className="d-flex justify-content-between align-items-start r1">
                <div className="pr">
                  <div className="avatar-wrapper">
                    {userData?.profileImg ? (
                      <img
                        src={`${process.env.REACT_APP_S3URL}/${userData?.profileImg}`}
                        alt="avatar"
                        className="profile-avatar"
                      />
                    ) : (
                      <img
                        src={dummyProfile}
                        alt="avatar"
                        className="profile-avatar"
                      />
                    )}
                  </div>
                  <div className="editImage">
                    <label>
                      <Edit />
                      <input
                        type="file"
                        name=""
                        id=""
                        onChange={(e) => handleImgUpload(e)}
                        accept="image/*"
                      />
                    </label>
                  </div>
                </div>
                <div className="d-flex gap-2">
                  {openEdit ? (
                    <button
                      className="themeBtn"
                      onClick={() => setOpenEdit(false)}
                    >
                      Cancel
                    </button>
                  ) : (
                    <button
                      className="themeBtn"
                      onClick={() => setOpenEdit(true)}
                    >
                      Edit Profile
                    </button>
                  )}
                  <button
                    className="themeBtn"
                    onClick={() => setShowPassModal(true)}
                  >
                    Update Password
                  </button>
                </div>
              </div>

              <hr />

              <div className="profile-detail">
                <div className="title">Full Name:</div>
                {openEdit ? (
                  <div>
                    <input
                      type="text"
                      className={"form-control"}
                      value={inputData?.name}
                      onChange={onTextChange}
                      name="name"
                    />
                  </div>
                ) : (
                  <>{userData?.name}</>
                )}
              </div>

              <div className="profile-detail">
                <div className="title">Date of Birth:</div>

                {openEdit ? (
                  <div>
                    <input
                      className={"form-control"}
                      type="date"
                      value={inputData?.dob}
                      onChange={onTextChange}
                      name="dob"
                    />
                  </div>
                ) : (
                  <>{userData?.dob}</>
                )}
              </div>

              {/* <div className="profile-detail">
                <strong>Username:</strong> {userData?.name}
              </div> */}

              <div className="profile-detail">
                <div className="title">Email Address:</div>

                {userData?.email}
              </div>

              <div className="profile-detail">
                <div className="title">Country:</div>

                {openEdit ? (
                  <div>
                    <CountrySelect onTextChange={onTextChange} />
                  </div>
                ) : (
                  <>{userData?.country}</>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Save Button */}
        {openEdit && (
          <div className="text-center mt-5">
            <button
              className="themeBtn mx-auto"
              onClick={handleSubmit}
              disabled={loader}
            >
              {loader && (
                <i
                  className="fa fa-spinner fa-pulse mx-2 mb-1"
                  style={{ position: "relative", top: "-0px" }}
                ></i>
              )}
              Save Changes
            </button>
          </div>
        )}
      </div>

      <ChangePasswordModal
        show={showPassModal}
        onHide={() => setShowPassModal(false)}
        email={userData?.email}
      />
    </div>
  );
};

const ChangePasswordModal = ({ show, onHide, email }) => {
  const alert = useAlert();
  const [step, setStep] = useState(1); // 1 = OTP, 2 = new password
  const [otp, setOtp] = useState("");
  const [verifiedOtp, setVerifiedOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const handleClose = () => {
    onHide();
    setStep(1);
    setOtp("");
    setVerifiedOtp("");
    setPassword("");
    setConfirmPassword("");
    setOtpSent(false);
    setShowPass(false);
    setShowConfirmPass(false);
  };

  const handleSendOtp = async () => {
    try {
      setLoader(true);
      const res = await api.sendOnlyOtp({ email });
      if (res?.success) {
        setOtpSent(true);
        alert.show("OTP sent to your email");
      } else {
        alert.show(res?.message || "Failed to send OTP");
      }
    } catch (err) {
      alert.show("Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length < 6) return alert.show("Please enter 6-digit OTP");
    try {
      setLoader(true);
      const res = await api.isOtpVerified({ email, otp });
      if (res?.success) {
        setVerifiedOtp(otp);
        setStep(2);
      } else {
        alert.show(res?.message || "Invalid OTP");
      }
    } catch (err) {
      alert.show("Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  const handleChangePassword = async () => {
    if (!password || !confirmPassword) return alert.show("Please fill all fields");
    if (password !== confirmPassword) return alert.show("Passwords do not match");
    if (password.length < 8) return alert.show("Password must be at least 8 characters");
    try {
      setLoader(true);
      const res = await api.changePassword({ otp: verifiedOtp, password, confirmPassword });
      if (res?.success) {
        alert.show("Password changed successfully");
        handleClose();
      } else {
        alert.show(res?.message || "Something went wrong");
      }
    } catch (err) {
      alert.show(err?.message || "Something went wrong");
    } finally {
      setLoader(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body>
        <div className="otpModalMain">
          <div className="closeIcon" onClick={handleClose}>
            <i className="fa-solid fa-xmark" />
          </div>

          {step === 1 ? (
            <>
              <h2 className="title">Verify Your Identity</h2>
              <div className="desc">
                We will send a 6-digit code to <strong>{email}</strong>
              </div>

              {!otpSent ? (
                <div className="text-center mt-4">
                  <button onClick={handleSendOtp} className="themeBtn w-100" disabled={loader}>
                    {loader && <i className="fa fa-spinner fa-pulse mx-2" />}
                    Send OTP
                  </button>
                </div>
              ) : (
                <>
                  <div className="otpInputMain mt-3">
                    <OtpInput
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      isInputNum={true}
                      separator={<span>-</span>}
                    />
                  </div>
                  <div className="text-center mt-3">
                    <button onClick={handleVerifyOtp} className="themeBtn w-100" disabled={loader}>
                      {loader && <i className="fa fa-spinner fa-pulse mx-2" />}
                      Verify OTP
                    </button>
                  </div>
                  <div className="text-center mt-2">
                    <small
                      style={{ cursor: "pointer", textDecoration: "underline" }}
                      onClick={handleSendOtp}
                    >
                      Resend OTP
                    </small>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <h2 className="title">Set New Password</h2>
              <div className="desc">Enter your new password below</div>
              <div className="mt-3">
                <div style={{ position: "relative" }} className="mb-3">
                  <input
                    type={showPass ? "text" : "password"}
                    className="form-control"
                    placeholder="New Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ paddingRight: 40 }}
                  />
                  <span
                    onClick={() => setShowPass(!showPass)}
                    style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#888" }}
                  >
                    {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
                  </span>
                </div>
                <div style={{ position: "relative" }}>
                  <input
                    type={showConfirmPass ? "text" : "password"}
                    className="form-control"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    style={{ paddingRight: 40 }}
                  />
                  <span
                    onClick={() => setShowConfirmPass(!showConfirmPass)}
                    style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#888" }}
                  >
                    {showConfirmPass ? <EyeOff size={18} /> : <Eye size={18} />}
                  </span>
                </div>
              </div>
              <div className="text-center mt-4">
                <button onClick={handleChangePassword} className="themeBtn w-100" disabled={loader}>
                  {loader && <i className="fa fa-spinner fa-pulse mx-2" />}
                  Save Password
                </button>
              </div>
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProfilePage;
